export function postData(url, body) {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.text();
    })
    .then((data) => {
      console.log(data);
      return true;
    })
    .catch(function (err) {
      console.log(err);
      return null;
    });
}
